import { FormEvent, useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAutenticacao } from '../lib/auth';
import { ErroApi } from '../lib/api';
import { Alerta, Botao, Campo, Cartao } from '../componentes/Interface';

export default function Login() {
  const { usuario, carregando, entrar, avisoSessao, limparAviso } = useAutenticacao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const local = useLocation();

  if (carregando) return <TelaCarregando />;
  if (usuario) return <Navigate to={(local.state as any)?.de ?? '/painel'} replace />;

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    limparAviso();
    setEnviando(true);
    try {
      await entrar(email, senha);
    } catch (e) {
      // ARMADILHA 12: o erro aparece com o motivo, nunca some em silencio
      setErro(e instanceof ErroApi ? e.message : 'Não consegui entrar. Tente de novo.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center bg-fundo px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center text-center">
          <img src="/logo-fundo.png" alt="Sara Osasco" className="h-24 w-24 rounded-3xl object-cover shadow-cartao" />
          <p className="mt-3 text-sm text-tinta-400">Entre para acessar o sistema</p>
        </div>

        <Cartao>
          {avisoSessao && (
            <div className="mb-4">
              <Alerta tipo="aviso">{avisoSessao}</Alerta>
            </div>
          )}
          {erro && (
            <div className="mb-4">
              <Alerta>{erro}</Alerta>
            </div>
          )}

          <form onSubmit={enviar} className="space-y-4">
            <Campo
              rotulo="E-mail"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="voce@saraosasco.com.br"
            />
            <Campo
              rotulo="Senha"
              type="password"
              autoComplete="current-password"
              required
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
            />
            <Botao type="submit" carregando={enviando} className="w-full">
              Entrar
            </Botao>
          </form>

          <div className="mt-4 space-y-2 text-center">
            <Link to="/esqueci-senha" className="block text-sm text-tinta-400 hover:text-tinta-900">
              Esqueci minha senha
            </Link>
            <Link
              to="/cadastro"
              className="block text-sm font-semibold text-tinta-900 hover:underline"
            >
              Ainda nao tenho acesso — criar meu cadastro
            </Link>
          </div>
        </Cartao>
      </div>
    </div>
  );
}

export function TelaCarregando() {
  return (
    <div className="flex min-h-full flex-col items-center justify-center gap-4 bg-fundo">
      <img src="/logo-fundo.png" alt="Sara Osasco" className="h-16 w-16 rounded-2xl object-cover" />
      <span className="h-6 w-6 animate-spin rounded-full border-2 border-tinta-200 border-t-tinta-900" />
    </div>
  );
}
